var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14664_21230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6939 8.56231L1.03739 0.725631C0.865779 0.625589 0.649887 0.631146 0.483816 0.731189C0.312209 0.831232 0.207031 1.00909 0.207031 1.20917C0.207031 1.20917 0.212567 1.9317 0.218103 3.1211L10.1657 13.1087L14.6939 8.56231Z",
    fill: "url(#paint0_linear_14664_21230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 3.12109C0.235357 7.41182 0.285178 17.8274 0.307321 23.0129L10.1719 13.1087L0.21875 3.12109Z",
    fill: "url(#paint1_linear_14664_21230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5103 13.0473L14.6939 8.56201L10.1602 13.1084L15.2751 18.2439L22.5158 14.0088C22.6874 13.9087 22.7926 13.7253 22.7926 13.5308C22.7926 13.3307 22.6819 13.1473 22.5103 13.0473Z",
    fill: "url(#paint2_linear_14664_21230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.301758 23.0129C0.312829 24.8637 0.318365 26.0476 0.318365 26.0476C0.318365 26.2476 0.423543 26.4311 0.59515 26.5255C0.766756 26.6256 0.977113 26.6256 1.14872 26.5255L15.2814 18.2498L10.1664 13.1143L0.301758 23.0129Z",
    fill: "url(#paint3_linear_14664_21230)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14664_21230",
    x1: 0.207031,
    y1: 6.88349,
    x2: 14.6965,
    y2: 6.88349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5BBC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB96A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14664_21230",
    x1: 0.216093,
    y1: 13.0694,
    x2: 10.1662,
    y2: 13.0694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45AFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14664_21230",
    x1: 10.1655,
    y1: 13.4065,
    x2: 22.7913,
    y2: 13.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FAB716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#FAC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC80F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14664_21230",
    x1: 0.304194,
    y1: 19.8572,
    x2: 15.2811,
    y2: 19.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7515B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14664_21230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6331,
    height: 26,
    fill: "white",
    transform: "translate(0.183594 0.625488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.ed13eac76b99d8c4817bd838ebd6aab7.svg";
export { ForwardRef as ReactComponent };